import { ref } from 'vue'
import FieldOptionsService from '@/Network/Services/FieldOptionsService'

type Option = { label: string; value: string }

// Cache em nível de módulo: a aba e o modal de histórico ficam montados ao mesmo
// tempo, e a lista de grupos operacionais não muda durante a sessão.
const options = ref<Option[]>([])
let inFlight: Promise<void> | null = null

export const useOperationalGroups = () => {
  const load = async () => {
    if (options.value.length > 0) return
    if (inFlight) return inFlight

    inFlight = (async () => {
      try {
        const service = new FieldOptionsService()
        const groups = await service.getOperationalGroups()
        options.value = groups.map((group) => ({ label: group.name, value: group.name }))
      } catch (error) {
        console.error('Falha ao buscar grupos operacionais:', error)
        options.value = []
      } finally {
        inFlight = null
      }
    })()

    return inFlight
  }

  return { options, load }
}
